import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-amount-selector',
    imports: [CommonModule],
    templateUrl: './amount-selector.component.html',
    styleUrls: ['./amount-selector.component.scss']
})
export class AmountSelectorComponent {
  @Input() selected: number | null = null;
  @Output() select = new EventEmitter<number>();

  amountsOneTime = [25, 55, 100, 250, 500, 1000];
  amountsMonthly = [15, 25, 40, 50, 100, 250];

  selectAmount(amount: number) {
    this.select.emit(amount);
  }
}
